import { useRef, useEffect, useMemo, useCallback } from 'react'
import { styled } from '@mui/material'
import { CalculatorVersion } from '@app/types'
import { CALCULATOR_VERSION, CONTAINER_ID } from '@app/constant/calculator'

declare global {
  interface Window {
    TI30?: any
    TI108?: any
    TI34?: any
    TI84?: any
    TI84PCE?: any
  }
}

interface Props {
  version: CalculatorVersion
}

export const TICalculator: React.FC<Props> = ({ version = 'TI108' }) => {
  const calculatorElementRef = useRef<HTMLDivElement>(null)

  const calculator = useMemo(() => {
    return CALCULATOR_VERSION[version]
  }, [version])

  const initializeCalculator = useCallback(() => {
    if ((window as any)?.[calculator.key]) {
      new (window as any)[calculator.key]({
        elementId: CONTAINER_ID,
        ROMLocation: `/examcalc/bin/${calculator.state}`,
        FaceplateLocation: `/examcalc/images/${calculator.image}`,
      })
    }
  }, [calculator])

  useEffect(() => {
    const cssHref = `/examcalc/css/${calculator.css}`
    const jsSrc = `/examcalc/js/${calculator.js}`
    const existingScript = document.querySelector(`script[src="${jsSrc}"]`)

    if (!document.querySelector(`link[href="${cssHref}"]`)) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.href = cssHref
      document.head.appendChild(link)
    }

    if (existingScript) {
      initializeCalculator()
    } else {
      const script = document.createElement('script')
      script.src = jsSrc
      script.async = true

      script.onload = () => {
        initializeCalculator()
      }

      document.body.appendChild(script)
    }
  }, [calculator, initializeCalculator])

  return <StyledCalculatorContainer id={CONTAINER_ID} ref={calculatorElementRef}></StyledCalculatorContainer>
}

const StyledCalculatorContainer = styled('div')(() => ({
  height: '100%',
  width: '100%',
}))
